<script lang="ts">

    import {createEventDispatcher, onDestroy, onMount, tick} from "svelte";

    const dispatcher = createEventDispatcher();
    export let value;

    export let minHeight = null;
    export let minLine = 3; // minHeight が設定されている場合、無視される
    export let placeholder = '';
    export let title = '';
    export let isEditable = true;

    export let maxlength = null;
    export let borderSizePx = 1;
    export let widthEm = null;

    export let required = false;

    let textareaElement = null;

    let resizeObserver = null;
    let previousHeight = null;


    onMount(() => {

        if (minHeight != null) {
            previousHeight = minHeight;
        }

        resizeObserver = new ResizeObserver(() => {
            changeHeight();
        });
        resizeObserver.observe(textareaElement);

        // 高さの初期設定
        setupHeight();

    });

    onDestroy(() => {
        if (resizeObserver != null) {
            resizeObserver.unobserve(textareaElement);
        }
    });

    function changeHeight() {
        if (previousHeight == null) {
            return;
        }
        const offsetHeight = textareaElement.offsetHeight;
        const offsetHeightPx = `${offsetHeight}px`;
        if (offsetHeightPx !== previousHeight) {
            // console.log('changeHeight', {offsetHeightPx, previousHeight, value});
            dispatcher('changeHeight', {height: offsetHeight});
        }

        previousHeight = offsetHeight;
    }

    function onInput(event) {
        setupHeight();

        dispatcher('input');
    }

    async function setupHeight() {
        if (textareaElement == null) {
            return;
        }
        textareaElement.style.height = "1em";
        await tick();
        let newScrollHeight = textareaElement.scrollHeight;
        newScrollHeight += (borderSizePx * 2); // 上下のボーダーサイズを加算
        textareaElement.style.height = newScrollHeight + 'px';

    }

    $: style = (() => {
        let style = '';
        if (minHeight != null) {
            style += `min-height: ${minHeight};`;

        } else if (minLine != null) {
            const minHeightEm = (minLine * 1.2) + 0.8;
            style += `min-height: ${minHeightEm}em;`;
        }
        if (widthEm != null) {
            style += `min-width: ${widthEm}em;`;
        }

        style += `border-size: ${borderSizePx}px`;

        return style;
    })();
</script>


<textarea class="text-area-view"
          style={style} bind:value={value} on:input={onInput} on:keydown
          placeholder={isEditable ? placeholder : ''}
          title={title}
          readonly={!isEditable}
          bind:this={textareaElement}
          maxlength={maxlength}
          required={required}

/>


<style lang="scss">
    textarea.text-area-view {
        min-height: 4.1em;
        line-height: 1.2em;
        padding-top: 0.4em;
        padding-bottom: 0.4em;

        margin-bottom: -0.3em;


    }
</style>